/* ----------------------------------------------------------------------------
the visitor's current time, in their own time zone, with its offset from UTC
(UTC-4, UTC+5:30), updated on the minute.
Renders nothing without JS, since the server can't know the visitor's zone.
---------------------------------------------------------------------------- */

export default class LocalClock extends HTMLElement {
	connectedCallback() {
		const lang = document.documentElement.lang || undefined;
		// 24-hour (14:05), since there's no AM/PM to tell morning from afternoon
		this.format = new Intl.DateTimeFormat(lang, {
			hour: '2-digit',
			minute: '2-digit',
			hourCycle: 'h23',
		});
		this.time = document.createElement('time');
		this.time.title = Intl.DateTimeFormat().resolvedOptions().timeZone;
		this.offset = document.createElement('span');
		this.replaceChildren(this.time, ' ', this.offset);
		this.tick();
	}

	disconnectedCallback() {
		clearTimeout(this.timer);
	}

	tick() {
		const now = new Date();
		this.time.dateTime = now.toISOString();
		this.time.textContent = this.format.format(now);
		// read every tick, since the offset changes when daylight saving starts or ends
		this.offset.textContent = utcOffset(now);
		// wake at the start of the next minute, so the clock never lags behind
		const wait = 60000 - (now.getSeconds() * 1000 + now.getMilliseconds());
		this.timer = setTimeout(() => this.tick(), wait);
	}
}

// UTC+2, UTC-4, UTC+5:30, UTC+0; getTimezoneOffset() counts minutes behind UTC
function utcOffset(date) {
	const minutes = -date.getTimezoneOffset();
	const sign = minutes < 0 ? '-' : '+';
	const hours = Math.floor(Math.abs(minutes) / 60);
	const rest = Math.abs(minutes) % 60;
	return `UTC${sign}${hours}${rest ? `:${String(rest).padStart(2, '0')}` : ''}`;
}

window.customElements.define('local-clock', LocalClock);
